import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import bn from '../../utils/bemnames';
import { GetErrorBoundryDetails } from '../../utils/dashboard-util';
import { debugError } from '../../utils/debug-logger';

const bem = bn.create('progressbar');

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null, hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    debugError('ErrorBoundary', 'caught error', {
      error,
      componentStack: errorInfo.componentStack,
      url: window.location.href,
    });

    const handleOnError = async (error, errorInfo) => {
      const url = window.location.href;
      await GetErrorBoundryDetails(url, error, errorInfo);
    };
    handleOnError(error.toString(), errorInfo.componentStack);

    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.hasCard) {
        return (
          <Card title={this.props.cardtitle ? this.props.cardtitle : ''}>
            <div className={bem.b('cr-page-spinner')}>
              <div className="progress-error w-100">
                <div className="w-100 text-center">
                  <i className="bi bi-exclamation-triangle-fill" />
                  <p className="mt-2 mb-0">
                    Oops, something&apos;s gone wrong. We have been made aware and will be looking into it
                  </p>
                  <p className="mt-0">
                    Click&nbsp;
                    <a className="text-secondary" href={`${window.origin}`}>
                      here
                    </a>
                    &nbsp;to go back to the dashboard
                  </p>
                </div>
              </div>
            </div>
          </Card>
        );
      }
      return (
        <div className={bem.b('cr-page-spinner')}>
          <div className="progress-error w-50">
            <div className="w-100 text-center">
              <i className="bi bi-exclamation-triangle-fill" />
              <p className="mt-2 mb-0">Oops, something&apos;s gone wrong </p>
              <p className="mt-0">
                Click&nbsp;
                <a className="text-secondary" href={`${window.origin}`}>
                  here
                </a>
                &nbsp;to go back to the dashboard
              </p>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};
